import { Address } from "./address";
import { Customer } from "./customer";
import { Equipment } from "./equipment";
import EquipmentType from "./equipmentType";
import { Note } from "./note";
import { Transaction } from "./transaction";

export class Invoice {
  invoice_id = -1;
  appointment_id = -1;
  job_id = -1;
  quote_type = "";
  summary?: string;
  format?: string;
  customer = new Customer();
  billing_customer = new Customer();
  service_address?: Address;
  billing_address?: Address;
  links?: {
    invoice_approve: string;
    invoice_email: string;
    invoice_pdf: string;
    invoice_refund: string;
    payment_create: string;
    payment_list: string;
    payment_receivers: string;
    equipment_link_create: string;
    update_details: string;
    invoice_product_usage: string;
    edit_invoice_date: string;
    invoice_break: string;
    void: string;
    update_batching: string;
    resubmit: string;
    update_display_membership_savings: string;
  } = undefined;
  signature?: {
    kind: string;
    image_url: string;
    signature_time: string;
  } = undefined;
  items_attributes: InvoiceLineItem[] = [];
  financials = {
    subtotal_cents: -1,
    discount_amount_cents: 0,
    refundable_amount_cents: 0,
    late_fee_cents: 0,
    sales_tax_cents: 0,
    total_cents: 0,
    total_transactions_cents: 0,
    balance_cents: 0,
    savings_cents: undefined as number | undefined
  };
  notes: Note[] = [];
  finalized: false;
  voided: false;
  invoice_date = ""; // Date
  next_payment_key = "";
  payments: Transaction[] = [];
  payment_create_url?: string;
  payment_list_url?: string;
  payment_receivers_url?: string;
  pdf_url?: string;
  display_membership_savings?: boolean;
  exclude_from_batching: boolean;
  accounting_class_id?: number | null;
  discount_line_item_accounting_classes?: boolean;
  original_billing_customer?: Customer;
  inferred_billing_customer?: Customer;
  qbo_sync_status?: string;
  qbo_id?: string;
  qbo_url?: string;
  constructor(params: Partial<Invoice> = {}) {
    Object.assign(this, params);
  }
}

export class InvoiceLineItem {
  id = -1;
  item_id = -1;
  item_type = "";
  unit_name = "";
  description = "";
  warranty = "";
  quantity = 0;
  unit_price_cents = 0;
  total_cents = 0;
  comparison_price_cents?: number = undefined;
  comparison_total_cents = 0;
  covered_systems = 0;
  type = "";
  invoice_format?: string;
  accounting_class_id?: number | null;
  equipment_request_status = "";
  equipment_links: EquipmentLink[] = [];
  links?: {
    time_override: string;
    pricebook_link: string;
    equipment_link_create: string;
  } = undefined;
  items_in_group?: InvoiceLineItem[] = [];

  constructor(params: Partial<InvoiceLineItem> = {}) {
    Object.assign(this, params);
  }
}

export class EquipmentLink {
  id = -1;
  invoice_line_item_id = -1;
  equipment_type = new EquipmentType();
  equipment?: Equipment = undefined;
  not_applicable = false;
  status = "";
  optional = false;
  links?: {
    equipment_link_update: string;
    equipment_link_destroy: string;
  } = undefined;

  constructor(params: Partial<EquipmentLink> = {}) {
    Object.assign(this, params);
  }
}

export enum EquipmentRequestStatus {
  FULFILLED = "fulfilled",
  UNFULFILLED = "unfulfilled",
  OPTIONAL = "optional"
}

export class InventoryUsage {
  id = -1;
  part_id = -1;
  inventory_location_id: number | null = null;
  quantity = 0;
  invoice_line_item_id: number | null = null;
  quote_line_item_id: number | null = null;
  part?: {
    id: number;
    name: string;
    vendor_sku: string;
    details: string;
  } = undefined;

  constructor(params: Partial<InventoryUsage> = {}) {
    Object.assign(this, params);
  }
}
